// import { Table, Button, Card, Flex, DatePicker } from 'antd';
// import Heading from '../../components/common/Heading/Heading';
// import dayjs from 'dayjs';
// import { useQuery } from '@tanstack/react-query';
// import { queryKeys } from '../../services/react-query/queryKeys';
// import { useSelector } from 'react-redux';
// import { getTreeTable } from '../../network/treeTable';
// const {RangePicker} = DatePicker
// const TreeTable = ({t}) => {
//     const {currentLang,companyName} = useSelector((state) => state.user);
//   const [expandedRowKeys, setExpandedRowKeys] = useState([]);
// const [ sourceData,setSourceData] = useState({from_date:dayjs().startOf('year').format('YYYY-MM-DD'),to_date:dayjs().format('YYYY-MM-DD'),
//     fiscal_year:dayjs().format('YYYY')
// })
//   const onExpand = (expanded, record) => {
//     if (expanded) {
//       setExpandedRowKeys((prev) => [...prev, record.key]);
//     } else {
//       setExpandedRowKeys((prev) => prev.filter((key) => key !== record.key));
//     }
//   };

// //   const data = [
// //     {
// //       key: '1',
// //       name: 'Parent 1',
// //       age: 40,
// //       address: '123 Parent Street',
// //       children: [
// //         {
// //           key: '1-1',
// //           name: 'Child 1.1',
// //           age: 18,
// //           address: '123 Child Street',
// //           children: [
// //             {
// //               key: '1-1-1',
// //               name: 'Grandchild 1.1.1',
// //               age: 5,
// //               address: '123 Grandchild Street',
// //             },
// //             {
// //               key: '1-1-2',
// //               name: 'Grandchild 1.1.2',
// //               age: 7,
// //               address: '456 Grandchild Street',
// //             },
// //           ],
// //         },
// //         {
// //           key: '1-2',
// //           name: 'Child 1.2',
// //           age: 20,
// //           address: '789 Child Street',
// //         },
// //       ],
// //     },
// //     {
// //       key: '2',
// //       name: 'Parent 2',
// //       age: 45,
// //       address: '456 Parent Street',
// //     },
// //   ];

// //   const columns = [
// //     {
// //       title: 'Name',
// //       dataIndex: 'name',
// //       key: 'name',
// //     },
// //     {
// //       title: 'Age',
// //       dataIndex: 'age',
// //       key: 'age',
// //     },
// //     {
// //       title: 'Address',
// //       dataIndex: 'address',
// //       key: 'address',
// //     },
// //     {
// //       title: 'Action',
// //       key: 'action',
// //     //   render: (_, record) => (
// //     //     <Button type="link" onClick={() => console.log(record)}>
// //     //       View Details
// //     //     </Button>
// //     //   ),
// //     },
// //   ];
//   const { data: getTreeDataDetails, isLoading } = useQuery({
//     queryKey: [
//       queryKeys.getTrialBalance,
//       currentLang,
//       companyName,
//       sourceData.from_date,
//       sourceData.to_date,
//       sourceData.fiscal_year
//     ],
//     queryFn: () =>
//         getTreeTable(
//         currentLang,
//         companyName,
//         sourceData.from_date,
//         sourceData.to_date,
//         sourceData.fiscal_year
//       ),
//   });
//   const columns = getTreeDataDetails?.message?.columns?.map((col) => ({
//     title: col?.label,
//     dataIndex: col?.fieldname,
//     key: col?.fieldname,
//     // width: col.width,
//   }));
//   const data = getTreeDataDetails?.message?.result?.map((item) => ({
//     key: item?.id,
//     ...item,
//   }));
//   return (
//     <div className="">
//       <Heading title={t.finance} subTitle={t.TrialBalance} path="/" />
//       <Flex
//           style={{
//             // justifyContent: 'space-between',
//             gap: '20px',
//             alignItems: 'center',
//             marginBottom: '20px',
//           }}
//         >
//         <RangePicker
//             format="YYYY/MM/DD"
//             style={{ width: '100%' }}
//             placeholder={['From Date', 'To Date']}
//             // defaultValue={[dayjs().isBefore(dayjs().add(4, 'month')), dayjs()]}
//             defaultValue={[dayjs().startOf('year'), dayjs()]}
//             value={[dayjs(sourceData.from_date), dayjs(sourceData.to_date)]}
//             onChange={(dates, dateStrings) => {
//               setSourceData({
//                 from_date: dateStrings[0],
//                 to_date: dateStrings[1],
//               });
//             }}
//           />
//           <DatePicker
//             style={{ width: '100%' }}
//             placeholder="Fiscal Year"
//             defaultValue={dayjs().format('YYYY')}
//             value={dayjs(sourceData.fiscal_year)}
//             format="YYYY"
//             onChange={(date, dateString) => {
//               setSourceData({
//                 ...sourceData,
//                 fiscal_year: dateString,
//               });
//             }}
//           />
//         </Flex>
//     <Card>
//         <Table
//           columns={columns}
//           dataSource={data}
//           expandable={{
//             expandedRowKeys,
//             onExpand,
//             rowExpandable: (record) => !!record.children,
//             expandedRowRender: (record) =>
//               record.children && (
//                 <Table
//                   columns={columns}
//                   dataSource={record.children}
//                   pagination={false}
//                   expandable={{
//                     rowExpandable: (childRecord) => !!childRecord.children,
//                     expandedRowRender: (childRecord) =>
//                       childRecord.children && (
//                         <Table
//                           columns={columns}
//                           dataSource={childRecord.children}
//                           pagination={false}
//                         />
//                       ),
//                   }}
//                 />
//               ),
//           }}
//           pagination={false}
//         />
//     </Card>
//     </div>
//   );
// };

// export default TreeTable;
// import React, { useState } from 'react';
// import { Table, Card, DatePicker, Row, Col } from 'antd';
// import dayjs from 'dayjs';
// import { useQuery } from '@tanstack/react-query';
// import { queryKeys } from '../../services/react-query/queryKeys';
// import { useSelector } from 'react-redux';
// import { getTreeTable } from '../../network/treeTable';
// const { RangePicker } = DatePicker;

// const TreeTable = ({ t }) => {
//   const { currentLang, companyName } = useSelector((state) => state.user);
//   const [expandedRowKeys, setExpandedRowKeys] = useState([]);
//   const [sourceData, setSourceData] = useState({
//     from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
//     to_date: dayjs().format('YYYY-MM-DD'),
//     fiscal_year: dayjs().format('YYYY'),
//   });

//   const onExpand = (expanded, record) => {
//     // console.log(expanded, record);

//     setExpandedRowKeys((prev) => {
//       if (expanded) {
//         return [record.key];
//       }
//       return [];
//     });
//   };

//   const { data: getTreeDataDetails, isLoading } = useQuery({
//     queryKey: [
//       queryKeys.getTrialBalance,
//       currentLang,
//       companyName,
//       sourceData.from_date,
//       sourceData.to_date,
//       sourceData.fiscal_year,
//     ],
//     queryFn: () =>
//       getTreeTable(
//         currentLang,
//         companyName,
//         sourceData.from_date,
//         sourceData.to_date,
//         sourceData.fiscal_year
//       ),
//   });

//   const columns = getTreeDataDetails?.message?.columns?.map((col) => ({
//     title: col?.label,
//     dataIndex: col?.fieldname,
//     key: col?.fieldname,
//   }));

//   const accountsTree = getTreeDataDetails?.message?.result?.map(account => ({
//     ...account,
//     key: account.account,
//     children: getTreeDataDetails?.message?.result?.filter(child => child.parent_account === account.account)
//   })).filter(account => account?.parent_account === null);

//   return (
//     <div>
//       <Card>
//         <Row>
//           <Col xs={24} md={12}>
//             <RangePicker
//               format="YYYY/MM/DD"
//               style={{ width: '100%' }}
//               placeholder={['From Date', 'To Date']}
//               defaultValue={[dayjs().startOf('year'), dayjs()]}
//               value={[dayjs(sourceData.from_date), dayjs(sourceData.to_date)]}
//               onChange={(dates, dateStrings) => {
//                 setSourceData({
//                   from_date: dateStrings[0],
//                   to_date: dateStrings[1],
//                 });
//               }}
//             />
//           </Col>
//           <Col xs={24} md={12}>
//             <DatePicker
//               style={{ width: '100%' }}
//               placeholder="Fiscal Year"
//               defaultValue={dayjs().format('YYYY')}
//               value={dayjs(sourceData.fiscal_year)}
//               format="YYYY"
//               onChange={(date, dateString) => {
//                 setSourceData({
//                   ...sourceData,
//                   fiscal_year: dateString,
//                 });
//               }}
//             />
//           </Col>
//         </Row>

//         <Table
//           columns={columns}
//           dataSource={accountsTree}
//           expandable={{
//             expandedRowKeys,
//             onExpand,
//             rowExpandable: (record) => !!record.children && record.children.length > 0,
//             expandedRowRender: (record) =>
//               record.children && (
//                 <Table
//                   columns={columns}
//                   dataSource={record.children}
//                   pagination={false}
//                   expandable={{
//                     rowExpandable: (childRecord) => !!childRecord.children && childRecord.children.length > 0,
//                     expandedRowRender: (childRecord) =>
//                       childRecord.children && (
//                         <Table
//                         //   columns={columns}
//                           dataSource={childRecord.children}
//                           pagination={false}
//                           showHeader={false}
//                           onHeaderRow={() => null}
//                           scroll={{ x: 'max-content' }}
//                           rowKey="key"

//                         />
//                       ),
//                   }}
//                 />
//               ),
//           }}
//           pagination={{ hideOnSinglePage: true }}
//           rowKey="key"
//           scroll={{ x: 'max-content' }}
//         />
//       </Card>
//     </div>
//   );
// };

// export default TreeTable;

// import React, { useState } from 'react';
// import { Table, Card, DatePicker, Row, Col } from 'antd';
// import dayjs from 'dayjs';
// import { useQuery } from '@tanstack/react-query';
// import { queryKeys } from '../../services/react-query/queryKeys';
// import { useSelector } from 'react-redux';
// import { getTreeTable } from '../../network/treeTable';
// const { RangePicker } = DatePicker;

// const TreeTable = ({ t }) => {
//   const { currentLang, companyName } = useSelector((state) => state.user);
//   const [expandedRowKeys, setExpandedRowKeys] = useState([]);
//   const [sourceData, setSourceData] = useState({
//     from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
//     to_date: dayjs().format('YYYY-MM-DD'),
//     fiscal_year: dayjs().format('YYYY'),
//   });

//   const onExpand = (expanded, record) => {
//     setExpandedRowKeys((prev) => {
//       if (expanded) {
//         return [record.key];
//       }
//       return [];
//     });
//   };

//   const { data: getTreeDataDetails, isLoading } = useQuery({
//     queryKey: [
//       queryKeys.getTrialBalance,
//       currentLang,
//       companyName,
//       sourceData.from_date,
//       sourceData.to_date,
//       sourceData.fiscal_year,
//     ],
//     queryFn: () =>
//       getTreeTable(
//         currentLang,
//         companyName,
//         sourceData.from_date,
//         sourceData.to_date,
//         sourceData.fiscal_year
//       ),
//   });

//   // الأعمدة الرئيسية
//   const columns = getTreeDataDetails?.message?.columns?.map((col) => ({
//     title: col?.label,
//     dataIndex: col?.fieldname,
//     key: col?.fieldname,
//   }));

//   // هيكلة البيانات الأصلية مع الأطفال
//   const accountsTree = getTreeDataDetails?.message?.result?.map(account => ({
//     ...account,
//     key: account.account,
//     children: getTreeDataDetails?.message?.result?.filter(child => child.parent_account === account.account)
//   })).filter(account => account?.parent_account === null);

//   // دالة لتوسيع الصفوف متعددة المستويات
//   const renderChildren = (record) => {
//     return record.children && (
//       <Table
//         columns={columns} // الأعمدة الرئيسية هنا
//         dataSource={record.children}
//         pagination={false}
//         expandable={{
//           rowExpandable: (childRecord) => !!childRecord.children && childRecord.children.length > 0,
//           expandedRowRender: (childRecord) => renderChildren(childRecord), // التوسيع المتعدد
//         }}
//         showHeader={false} // لا تظهر الأعمدة في هذا الجدول الفرعي
//         rowKey="key"
//       />
//     );
//   };

//   return (
//     <div>
//       <Card>
//         <Row>
//           <Col xs={24} md={12}>
//             <RangePicker
//               format="YYYY/MM/DD"
//               style={{ width: '100%' }}
//               placeholder={['From Date', 'To Date']}
//               defaultValue={[dayjs().startOf('year'), dayjs()]}
//               value={[dayjs(sourceData.from_date), dayjs(sourceData.to_date)]}
//               onChange={(dates, dateStrings) => {
//                 setSourceData({
//                   from_date: dateStrings[0],
//                   to_date: dateStrings[1],
//                 });
//               }}
//             />
//           </Col>
//           <Col xs={24} md={12}>
//             <DatePicker
//               style={{ width: '100%' }}
//               placeholder="Fiscal Year"
//               defaultValue={dayjs().format('YYYY')}
//               value={dayjs(sourceData.fiscal_year)}
//               format="YYYY"
//               onChange={(date, dateString) => {
//                 setSourceData({
//                   ...sourceData,
//                   fiscal_year: dateString,
//                 });
//               }}
//             />
//           </Col>
//         </Row>

//         <Table
//           columns={columns}
//           dataSource={accountsTree}
//           loading={isLoading}
//           expandable={{
//             expandedRowKeys,
//             onExpand,
//             rowExpandable: (record) => !!record.children && record.children.length > 0,
//             expandedRowRender: (record) => renderChildren(record),
//           }}
//           pagination={{ hideOnSinglePage: true }}
//           rowKey="key"
//           scroll={{ x: 'max-content' }}
//         />
//       </Card>
//     </div>
//   );
// };

// export default TreeTable;
import React, { useState } from 'react';
import { Table, Card, DatePicker, Row, Col } from 'antd';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import { getTreeTable } from '../../network/treeTable';
import Heading from '../../components/common/Heading/Heading';
import DashboardCards from '../Dashboard/DashboardCards';
const { RangePicker } = DatePicker;

const TrialBalance = ({ t }) => {
  const { currentLang, companyName } = useSelector((state) => state.user);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [sourceData, setSourceData] = useState({
    from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
    to_date: dayjs().format('YYYY-MM-DD'),
    fiscal_year: dayjs().format('YYYY'),
  });

  const onExpand = (expanded, record) => {
    setExpandedRowKeys((prev) => {
      if (expanded) {
        return [...prev, record.key];
      }
      return prev.filter((key) => key !== record.key);
    });
  };

  const { data: getTreeDataDetails, isLoading } = useQuery({
    queryKey: [
      queryKeys.getTrialBalance,
      currentLang,
      companyName,
      sourceData.from_date,
      sourceData.to_date,
      sourceData.fiscal_year,
    ],
    queryFn: () =>
      getTreeTable(
        currentLang,
        companyName,
        sourceData.from_date,
        sourceData.to_date,
        sourceData.fiscal_year
      ),
  });

  const columns = getTreeDataDetails?.message?.columns?.map((col) => ({
    title: col?.label,
    dataIndex: col?.fieldname,
    key: col?.fieldname,
  }));

  const buildAccountsTree = (accounts) => {
    const map = new Map();

    accounts?.forEach((account) => {
      map.set(account?.account, { ...account, key: account?.account });
    });

    const result = [];
    accounts?.forEach((account) => {
      if (account?.parent_account) {
        const parent = map.get(account.parent_account);
        if (parent) {
          if (!parent.children) {
            parent.children = [];
          }
          parent.children.push(map.get(account.account));
        }
      } else {
        result.push(map.get(account.account));
      }
    });
    const cleanTree = (nodes) => {
      return nodes?.map((node) => {
        const { children, ...rest } = node;
        return children && children.length > 0
          ? { ...rest, children: cleanTree(children) }
          : rest;
      });
    };

    return cleanTree(result.filter((account) => account?.key !== undefined));
  };

  const accountsTree = buildAccountsTree(
    getTreeDataDetails?.message?.result || []
  );
  console.log(accountsTree);

  return (
    <div>
      {/* <Heading title={t.Finance} subTitle={t.TrialBalance} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Row
          style={{
            marginBottom: 20,
          }}
          gutter={[16, 16]}
        >
          <Col xs={24} md={12}>
            <RangePicker
              format="YYYY/MM/DD"
              style={{ width: '100%' }}
              placeholder={['From Date', 'To Date']}
              defaultValue={[dayjs().startOf('year'), dayjs()]}
              value={[dayjs(sourceData.from_date), dayjs(sourceData.to_date)]}
              onChange={(dates, dateStrings) => {
                setSourceData({
                  ...sourceData,
                  from_date: dateStrings[0],
                  to_date: dateStrings[1],
                });
              }}
            />
          </Col>
          <Col xs={24} md={12}>
            <DatePicker
              style={{ width: '100%' }}
              placeholder="Fiscal Year"
              defaultValue={dayjs().format('YYYY')}
              value={dayjs(sourceData.fiscal_year)}
              format="YYYY"
              onChange={(date, dateString) => {
                setSourceData({
                  ...sourceData,
                  fiscal_year: dateString,
                });
              }}
            />
          </Col>
        </Row>

        <Table
          className="table_custom"
          columns={columns}
          dataSource={accountsTree}
          // expandable={{
          //   expandedRowKeys,
          //   onExpand,
          //   rowExpandable: (record) => !!record.children && record.children.length > 0,
          //   expandedRowRender: (record) => renderChildren(record),
          // }}
          loading={isLoading}
          pagination={{ hideOnSinglePage: true }}
          // rowKey="key"
          scroll={{ x: 'max-content' }}
        />
      </Card>
    </div>
  );
};

export default TrialBalance;

// import React, { useState } from 'react';
// import { Table, Card, DatePicker, Button, Flex } from 'antd';
// import Heading from '../../components/common/Heading/Heading';
// import dayjs from 'dayjs';
// import { useQuery } from '@tanstack/react-query';
// import { queryKeys } from '../../services/react-query/queryKeys';
// import { useSelector } from 'react-redux';
// import { getTreeTable } from '../../network/treeTable';

// const { RangePicker } = DatePicker;

// const TreeTable = ({ t }) => {
//   const { currentLang, companyName } = useSelector((state) => state.user);
//   const [expandedRowKeys, setExpandedRowKeys] = useState([]);
//   const [sourceData, setSourceData] = useState({
//     from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
//     to_date: dayjs().format('YYYY-MM-DD'),
//     fiscal_year: dayjs().format('YYYY'),
//   });

//   const onExpand = (expanded, record) => {
//     if (expanded) {
//       setExpandedRowKeys((prev) => [...prev, record.key]);
//     } else {
//       setExpandedRowKeys((prev) => prev.filter((key) => key !== record.key));
//     }
//   };

//   const { data: getTreeDataDetails, isLoading } = useQuery({
//     queryKey: [
//       queryKeys.getTrialBalance,
//       currentLang,
//       companyName,
//       sourceData.from_date,
//       sourceData.to_date,
//       sourceData.fiscal_year,
//     ],
//     queryFn: () =>
//       getTreeTable(
//         currentLang,
//         companyName,
//         sourceData.from_date,
//         sourceData.to_date,
//         sourceData.fiscal_year
//       ),
//   });

//   // تحضير الأعمدة
//   const columns = getTreeDataDetails?.message?.columns?.map((col) => ({
//     title: col?.label,
//     dataIndex: col?.fieldname,
//     key: col?.fieldname,
//   }));

//   // تحضير البيانات مع الأطفال
//   let data = getTreeDataDetails?.message?.result?.map((item) => ({
//     key: item?.id,
//     ...item,
//     children: [],
//   }));

//   // عملية إضافة الحسابات في children
//   const accountToFind = "1 - الأصول - S"; // الحساب الذي نبحث عنه
//   const filteredData = data?.filter((item) => item.account === accountToFind);

//   filteredData?.forEach((parentAccount) => {
//     // إضافة الحسابات الفرعية إلى children
//     data = data?.map((item) => {
//       if (item?.parent_account === parentAccount?.account) {
//         item?.children.push({ ...item }); // إضافة الحساب كـ child
//       }
//       return item;
//     });
//   });

//   // تصفية الـ data لإزالة الحسابات التي تم إضافتها كـ children
//   data = data?.filter((item) => item.account !== accountToFind);

//   return (
//     <div>
//       <Heading title={t.finance} subTitle={t.TrialBalance} path="/" />
//       <Flex
//         style={{
//           gap: '20px',
//           alignItems: 'center',
//           marginBottom: '20px',
//         }}
//       >
//         <RangePicker
//            format="YYYY/MM/DD"
//            style={{ width: '100%' }}
//            placeholder={['From Date', 'To Date']}
//            // defaultValue={[dayjs().isBefore(dayjs().add(4, 'month')), dayjs()]}
//            defaultValue={[dayjs().startOf('year'), dayjs()]}
//            value={[dayjs(sourceData.from_date), dayjs(sourceData.to_date)]}
//            onChange={(dates, dateStrings) => {
//              setSourceData({
//                from_date: dateStrings[0],
//                to_date: dateStrings[1],
//              });
//            }}
//         />
//         <DatePicker
//           style={{ width: '100%' }}
//           placeholder="Fiscal Year"
//           defaultValue={dayjs().format('YYYY')}
//         //   value={dayjs(sourceData.fiscal_year)}
//           format="YYYY"
//           onChange={(date, dateString) => {
//             setSourceData({
//               ...sourceData,
//               fiscal_year: dateString,
//             });
//           }}
//         />
//       </Flex>
//       <Card>
//         <Table
//           columns={columns}
//           dataSource={data}
//           expandable={{
//             expandedRowKeys,
//             onExpand,
//             rowExpandable: (record) => !!record.children,
//             expandedRowRender: (record) =>
//               record.children && (
//                 <Table
//                   columns={columns}
//                   dataSource={record.children}
//                   pagination={false}
//                   expandable={{
//                     rowExpandable: (childRecord) => !!childRecord.children,
//                     expandedRowRender: (childRecord) =>
//                       childRecord.children && (
//                         <Table
//                           columns={columns}
//                           dataSource={childRecord.children}
//                           pagination={false}
//                         />
//                       ),
//                   }}
//                 />
//               ),
//           }}
//           pagination={false}
//         />
//       </Card>
//     </div>
//   );
// };

// export default TreeTable;
